import React, { useState, useMemo, useRef, useCallback } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { getCategoryOrSeriesMap, findSeriesKeylistByKey } from "utils";
import { SearchInput } from "components/Inputs/SearchInput";
import { useClickOutside, useTranslate } from "hooks";
import {
  useProductsOverviewActions,
  useProductsOverviewStore,
} from "stores/productsOverviewStore";
import { productNavigationHandler } from "utils/productNavigationHandler";
import { useAllProducts } from "hooks/productHooks/useAllProducts";
import { SearchResults } from "./SearchResults";

import s from "./ProductsOverview.module.scss";
import { useProjectDataStore } from "stores/projectStore";

export const ProductsOverviewSearch = Scrivito.connect(
  ({ isModalActive, id, dummy, wizardType, modal, handleBackAction }) => {
    const translate = useTranslate();
    const dropdownRef = useRef();
    const [query, setQuery] = useState("");
    const projectId = useProjectDataStore((state) => state.projectId);
    const allProducts = useAllProducts();
    const productCategoryId = useProductsOverviewStore(
      (state) => state.productCategoryId,
    );

    const {
      setProductCategoryId,
      setProductsContent,
      setCategoryHeadline,
      navigateToConfiguratorPage,
      navigateToProductListPage,
    } = useProductsOverviewActions();

    const productsContent = useProductsOverviewStore(
      (state) => state.productsContent,
    );
    const [categoryMap, seriesMap] =
      allProducts && getCategoryOrSeriesMap(allProducts);

    const findCategoryByName = (value) => {
      if (!value || !Array.isArray(listOfCategories)) {
        return null;
      }

      const lowerValue = value.toLowerCase();

      return (
        listOfCategories.find(
          (category) =>
            typeof category.name === "string" &&
            category.name.toLowerCase() === lowerValue,
        ) || null
      );
    };

    const handleClick = (item, isSerie) => {
      productNavigationHandler({
        product: { ...item, isSerie },
        isModalActive,
        id,
        dummy,
        wizardType,
        handleBackAction,
        modal,
        setProductCategoryId,
        navigateToConfiguratorPage,
        projectId,
        navigateToProductListPage,
        setQuery,
        setCategoryHeadline,
        findSeriesKeylistByKey,
        seriesMap,
        productCategoryId,
        findCategoryByName,
      });
    };
    const handleSearchInputChange = (e) => {
      const value = e.target.value || "";
      setQuery(value);
      if (!value) {
        setProductsContent(productsContent);
      }
    };

    const listOfSeries = useMemo(
      () => Array.from(seriesMap.values()),
      [seriesMap],
    );
    const listOfCategories = useMemo(
      () => Array.from(categoryMap.values()),
      [categoryMap],
    );

    const handleClickOutsideDropdown = useCallback(() => {
      setQuery("");
    }, []);

    useClickOutside(dropdownRef, handleClickOutsideDropdown);

    return (
      <div className="d-flex flex-column" ref={dropdownRef}>
        <div className={cx(s.searchDiv)}>
          <SearchInput
            classNames={cx(s.productsOverviewSearch, {
              "bg-light": !isModalActive,
            })}
            placeHolder={translate("SEARCH_FIELD_PLACEHOLDER")}
            value={query}
            onChange={handleSearchInputChange}
          />
        </div>
        {query && (
          <div className={cx(s.searchDiv, s.searchResultsDiv)}>
            <div className={cx(s.searchResults, "p-2 mt-2")}>
              <div className="col-12">
                <SearchResults
                  isModalActive={isModalActive}
                  results={isModalActive ? productsContent : listOfSeries}
                  title={translate("PRODUCT_SEARCH_SERIES_RESULTS_TITLE")}
                  query={query}
                  handleClick={handleClick}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  },
);
